module.exports = __webpack_public_path__ + "img/eye.efe460ce.svg";